
import { computed, ref, defineComponent } from 'vue';
import commonApi from '@/api/common';
import jsonApi from '@/api/json';
import environment from '@/untils/environment';
import { message as $message } from 'ant-design-vue';

const OPTIONS = ['Apples', 'Nails', 'Bananas', 'Helicopters'];

const Parm: {
  [x: string]: string | number | null | [];
} = {
  shopType: null,
  mainCategory: [],
  qualificationPhotos: '',
  idCardFont: '',
  idCardBack: '',
  idCardHand: '',
  shopFont: '',
  shopInside: '',
  shopPrice: '',
};

export default defineComponent({
  name: 'CertifiedShop',
  setup() {
    const selectedItems = ref<string[]>([]);

    const filteredOptions = computed(() => OPTIONS.filter((o) => !selectedItems.value.includes(o)));

    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };

    return {
      selectedItems,
      filteredOptions,
      error,
      success,
    };
  },
  components: {
  },
  data() {
    return {
      shopCompanyList: [],
      shopMainCatList: [],
      environ: environment,
      params: Parm,
    };
  },
  mounted() {
    this.getJson();
  },
  methods: {
    getJson() {
      jsonApi.shopCompanyType().then((data: Record<string, object>) => {
        Object.keys(data).forEach((key) => {
          console.log(key);
          this.shopCompanyList.push(data[key] as never);
        });
        console.log(this.shopCompanyList);
      });
      jsonApi.shopMainGoods().then((data: Record<string, object>) => {
        Object.keys(data).forEach((key) => {
          console.log(key);
          this.shopMainCatList.push(data[key] as never);
        });
        console.log(this.shopMainCatList);
      });
    },
    uploadImg(files: {
      filename: string;
      file: {};
      }) {
      console.log(files);
      const formdata = new FormData();
      const file = files.file as unknown as Blob;
      formdata.append('files', file);
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      commonApi.uploadImg(formdata).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          const key = files.filename;
          console.log(key);
          this.params[key] = data.url;
          console.log(this.params);
        } else {
          this.error(message);
          console.log(message);
        }
      });
    },
    supplementShop() {
      console.log(this.params);
      if (!this.params.shopType) {
        this.error('请选择主体类型');
        return;
      }
      const mainCategory = this.params.mainCategory as string[];
      if (mainCategory.length === 0 || mainCategory.length > 5) {
        this.error('经营类目至少选择1个,最多选择5个');
        return;
      }
      if (!this.params.qualificationPhotos) {
        this.error('请上传社会信用代码证');
        return;
      }
      if (!this.params.idCardFont) {
        this.error('请上传证件照正面');
        return;
      }
      if (!this.params.idCardBack) {
        this.error('请上传证件照背面');
        return;
      }
      // if (!this.params.idCardHand) {
      //   this.error('请上传法人手持证件照');
      //   return;
      // }
      if (!this.params.shopFont) {
        this.error('请上传门店头照片');
        return;
      }
      if (!this.params.shopInside) {
        this.error('请上传门店内景照片');
        return;
      }
      if (!this.params.shopPrice) {
        this.error('请上传门店收银台照片');
        return;
      }
      interface Data{
        data: Shopinfo;
        success: boolean;
        message: string;
      }
      interface Shopinfo{
        shopName: string;
        shopVerifySubmitStatus: number;
      }

      const main = mainCategory ? mainCategory.join(',') : '';
      const param = {
        extendMap: {
          shopType: this.params.shopType,
          mainCategory: main,
          qualificationPhotos: this.params.qualificationPhotos,
          idCardPhotos: `${this.params.idCardFont},${this.params.idCardBack},${this.params.idCardHand}`,
          shopPhotos: `${this.params.shopFont},${this.params.shopInside},${this.params.shopPrice}`,
        },
      };
      console.log(param);
      commonApi.submitShopVerify(param).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          const parent = this.$parent as unknown as {[x: string]: Function};
          parent.nextAuthenticationStatus(1);
        } else {
          this.error(message);
          console.log(message);
        }
      });
    },
  },
});
